import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Refresh from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';
import { Chart } from '@totalsoft/rocket-ui';
import { getChartColors } from 'components/dashboard/utils';
import { Grid, useTheme, alpha } from '@mui/material';
import { ChartPaperContainer, ChartRefreshButton, ChartWrapper } from './AverageChartsStyles';

const ActiveContractChart = ({ activeContractChartData, loadActiveContractChartData }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = getChartColors(theme.palette.primary.main, activeContractChartData.labels.length);

  const data = {
    labels: activeContractChartData.labels,
    datasets: [
      {
        label: 'Approved',
        data: activeContractChartData.series[0],
        fill: true,
        backgroundColor: alpha(colors[0], 0.75),
        borderColor: alpha(colors[0], 0.9)
      },
      {
        label: 'In work',
        data: activeContractChartData.series[1],
        fill: true,
        backgroundColor: colors.length > 1 ? alpha(colors[1], 0.75) : alpha(colors[0], 0.75),
        borderColor: colors.length > 1 ? alpha(colors[1], 0.9) : alpha(colors[0], 0.9)
      }
    ]
  };
  const [showFooterArea, setShowFooterArea] = useState(false);

  const handleChartHover = useCallback(() => {
    setShowFooterArea(true);
  }, []);

  const handleChartLeave = useCallback(() => {
    setShowFooterArea(false);
  }, []);

  return (
    <ChartPaperContainer onMouseEnter={handleChartHover} onMouseLeave={handleChartLeave}>
      <Grid container alignItems='center'>
        <ChartWrapper item xs={12} translate={showFooterArea}>
          <Chart
            title={t('Dashboard.ActiveContractEvolution')}
            type='line'
            data={data}
            cardProps={{
              sx: {
                height: '100%'
              }
            }}
            height={200}
            options={{
              maintainAspectRatio: false,
              elements: {
                line: {
                  tension: 0.4
                }
              },
              plugins: {
                legend: {
                  display: false
                },
                tooltip: {
                  callbacks: {
                    label: function () {
                      return this.dataPoints[0]?.formattedValue;
                    }
                  }
                }
              }
            }}
          />
        </ChartWrapper>
        {showFooterArea && (
          <Grid container>
            <Grid item xs={12}>
              <ChartRefreshButton variant='text' tooltip={t('Dashboard.Refresh')} onClick={loadActiveContractChartData} size='tiny'>
                <Refresh fontSize='small' />
              </ChartRefreshButton>
            </Grid>
          </Grid>
        )}
      </Grid>
    </ChartPaperContainer>
  );
};

ActiveContractChart.propTypes = {
  activeContractChartData: PropTypes.object,
  loadActiveContractChartData: PropTypes.func
};

export default ActiveContractChart;
